import { injectable } from "@launchtray/tsyringe-async";
import { PieceColor } from "../../../enums/PieceColor";
import { TriangleRotationStatus } from "../../../enums/TriangleRotationStatus";
import { SquareModel } from "../../../models/square/impl/SquareModel";
import { ISquareModel } from "../../../models/square/ISquareModel";
import { ISquareModelFactory } from "../ISquareModelFactory";

@injectable()
export class EmptySquareModelFactory implements ISquareModelFactory {
    
    public constructor() {}

    public createSquare(rotationStatus: TriangleRotationStatus, color: PieceColor): ISquareModel {
        return new SquareModel([]);
    }
}